export enum OrderListAction {
	edit,
	delete,
	add,
	remove,
	note
}
